import { render, staticRenderFns } from "./CloseRequest.vue?vue&type=template&id=297d56c0&scoped=true"
import script from "./CloseRequest.vue?vue&type=script&lang=js"
export * from "./CloseRequest.vue?vue&type=script&lang=js"
import style0 from "./CloseRequest.vue?vue&type=style&index=0&id=297d56c0&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "297d56c0",
  null
  
)

export default component.exports